<template>
  <el-table-column
    prop="exit"
    sortable="custom"
    label="Kilépés"
    min-width="120"
  >
    <template slot-scope="scope">
      {{ scope.row.exit_time }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'location.value',
  };
</script>
